import { trackEvent } from 'tracking/tracking';
import { ViewIds } from '@ardoq/api-types';

export enum QuickPerspectiveType {
  WORKSPACE_FILTER = 'workspace filter',
  COMPONENT_FILTER = 'component filter',
  REFERENCE_FILTER = 'reference filter',
  DYNAMIC_FILTER = 'dynamic filter',
}

// Tracks the use and type of quick perspectives
export const trackToggledQuickPerspective = (metadata: {
  type: QuickPerspectiveType;
  isEnabling: boolean;
  activeView: ViewIds;
}) => trackEvent('Toggled quick perspective filter', metadata);
